import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { FillAccountError } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: FillAccountError;
  fillAccount(request: Boundaries["fillAccount"]["request"]): void;
}

function useFillAccount(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isFillAccountRequestPending),
    isRequestSuccess: useSelector(selector.isFillAccountRequestSuccess),
    isRequestFailure: useSelector(selector.isFillAccountRequestFailure),
    error: useSelector(selector.getFillAccountError),
    fillAccount: core.fillAccount,
  };
}

export { useFillAccount };
